import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GateWayService } from 'src/app/services/gateway.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, combineLatest, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { GateWayAttributeActions, GateWayAttributeActionTypes } from '../actions/gateway-attribute.actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import {PreferenceService} from '../../../services/preference.service';

@Injectable()
export class GateWayAttributeEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private getwayService = inject(GateWayService);
  private preferenceService = inject(PreferenceService);

  constructor() {}

  ReadMgtAttribute$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayAttributeActionTypes.ReadMgtAttribute),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadMgtAttribute
      };
      let param = {}
      if (action.payload !== null && action.payload.Category !== null) {
        param = {
          otp: user.otp,
          Category: action.payload.Category 
        }
      } else {
        param = {
          otp: user.otp
        }
      }
      return this.getwayService.ReadMgtAttribute(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.UpsertMgtAttribute(res.msg.body),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadMgtAttributeFail()];
        })
      );
    })
  ));
  ReadAttribute$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayAttributeActionTypes.ReadAttribute),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadAttribute
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.ReadAttribute(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.UpsertAttribute(res.msg.body),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadAttributeFail()];
        })
      );
    })
  ));
  AddMgtAttribute$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayAttributeActionTypes.AddMgtAttribute),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddMgtAttribute
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.AddMgtAttribute(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadMgtAttribute(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Add Attribute Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Add Attribute Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  UpdateMgtAttribute$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayAttributeActionTypes.UpdateMgtAttribute),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateMgtAttribute
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.UpdateMgtAttribute(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadMgtAttribute(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Update Attribute Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Update Attribute Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  DeleteMgtAttribute$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayAttributeActionTypes.DeleteMgtAttribute),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.DeleteMgtAttribute
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.DeleteMgtAttribute(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadMgtAttribute(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Delete Attribute Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Delete Attribute Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
}
